import { IBVRefinementItem } from '../../common/models/BVRefinements/IBVRefinementItem';
import { FILTER_TYPES } from './filter-types';

/**
 * @summary Get customers page's refinements definition for filter generation
 */
export const CUSTOMERS_REFINEMENT: IBVRefinementItem[] = [
    {
        key: 'BV_SEARCH_Customer',
        label: '',
        renderInline: true,
        type: FILTER_TYPES.SEARCH
    }
];

/**
 * @summary Get products page's refinements definition for filter generation
 */
export const JEWERLY_REFINEMENT: IBVRefinementItem[] = [
    {
        key: 'BV_BOOLEAN_Novelties',
        label: 'Novelties',
        innerLabel: 'Novelties',
        renderInline: true,
        type: FILTER_TYPES.BOOLEAN
    },
    {
        key: 'BV_BOOLEAN_Limited',
        label: 'Limited Edition',
        innerLabel: 'Limited E.',
        renderInline: true,
        type: FILTER_TYPES.BOOLEAN
    },
    {
        key: 'BV_BOOLEAN_Exhibition',
        label: 'Exhibition Novelties',
        innerLabel: 'Exhibition N.',
        renderInline: true,
        type: FILTER_TYPES.BOOLEAN,
    }
];

export const WATCHES_REFINEMENT: IBVRefinementItem[] = [
    {
        key: 'BV_BOOLEAN_Novelties',
        label: 'Novelties',
        innerLabel: 'Novelties',
        renderInline: true,
        type: FILTER_TYPES.BOOLEAN
    },
    {
        key: 'BV_BOOLEAN_Limited',
        label: 'Limited Edition',
        innerLabel: 'Limited E.',
        renderInline: true,
        type: FILTER_TYPES.BOOLEAN
    },
    {
        key: 'BV_BOOLEAN_Exhibition',
        label: 'Exhibition Novelties',
        innerLabel: 'Exhibition N.',
        renderInline: true,
        type: FILTER_TYPES.BOOLEAN,
    },
    {
        key: 'BV_GENDER_Gender',
        label: 'Gender',
        defaultValue: 'Lady',
        renderInline: true,
        type: FILTER_TYPES.GENDER
    }
];

export const GLOBAL_SEARCH_REFINEMENT: IBVRefinementItem[] = [
    {
        key: 'BV_GLOBAL_SEARCH_Search',
        label: '',
        renderInline: true,
        type: FILTER_TYPES.GLOBAL_SEARCH
    }
];